// import ReactGA from 'react-ga';
import React from "react";
import { Route,useLocation } from "react-router-dom";
import Header from "../common/Header/Header";
import NewFooter from "../common/Footer/NewFooter";
import Loader from "../common/Loader/Loader";
import "../../assets/css/base.css";
import "../../assets/css/style.css";
import routes from "../../routes";
import constant from "../../common/constant";
// eslint-disable-next-line no-unused-vars
import unregister from "../../interceptor";




function App() {
  const location = useLocation()
  const routeComponents = routes.map((route,i) => <Route key={i} {...route} />);
  const showElement = constant.inclusionArray.indexOf(location.pathname) !== -1;
    return (
      <div>
        {showElement && <Header/>}
        <Loader />
        {routeComponents}
        {showElement && <NewFooter />}
       
      </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js